export default function Feature(handle, {
    matchContainerClass,
}) {


    const resizeContainer = handle.querySelector('.local-video__video');
    let resizeTimeout = null;

    function selectVideo() {

        clearTimeout(resizeTimeout);

        let height = resizeContainer.clientHeight;
        let width = resizeContainer.clientWidth;

        resizeTimeout = setTimeout(() => {

            if (height > width) {
                // Do Nothing
                resizeContainer.classList.add('desktop-height-control');

                resizeContainer.classList.remove('desktop-width-control');
                resizeContainer.classList.remove('mobile-width-control');
            } else {
                if (height / width > 0.5625) {
                    resizeContainer.classList.add('desktop-width-control');

                    resizeContainer.classList.remove('desktop-height-control');
                    resizeContainer.classList.remove('mobile-width-control');
                } else {
                    resizeContainer.classList.add('mobile-width-control');

                    resizeContainer.classList.remove('desktop-height-control');
                    resizeContainer.classList.remove('desktop-width-control');
                }
            }
        }, 250);


    }
    selectVideo();
    window.addEventListener('resize', selectVideo);




}